/*
 * @Descripttion:
 * @version:
 * @Author: 廖图图
 * @Date: 2022-01-19 11:27:09
 * @LastEditors: 廖图图
 * @LastEditTime: 2022-01-19 16:34:11
 */
/**
 * 视图
 */
const workOrder = {
  listMyCustomer: "/api/listMyCustomer", //我的客户列表
  createNewAddressInfoAndSetPri: "/api/createNewAddressInfoAndSetPri", //添加电力运维客户联系信息
  listCustomerAddress: "/api/listCustomerAddress", //获取客户企业项目地址
  modifyNewAddressInfo: "/api/modifyNewAddressInfo", //修改电力运维客户联系信息
  removeNewAddressInfo: "/api/removeNewAddressInfo", //删除电力运维客户联系信息
  listServiceRegionByCompanyId: "/api/listServiceRegionByCompanyId",
  listElectricOperationsWorkBases: "/api/listElectricOperationsWorkBases",

  createUser: "/api/createUser",
  modifyUserInfo: "/api/modifyUserInfo",
};

export default workOrder;
